<div class="login-container">
    <app-exam-header [pageTitle]="'Reset Password'"></app-exam-header>
    <div class="login-content-wrapper">
        <div class="login-row">
            <!-- Left side - Image section -->
            <div class="login-image-section">
                <div class="image-content">
                    <img src="../../../../assets/images/login.png" alt="Reset Password Illustration">
                </div>
            </div>
            
            <!-- Right side - Reset Password form section -->
            <div class="login-form-section">
                <div class="login-form-wrapper">
                    <div class="login-form-header">
                        <h2>Reset Password</h2>
                        <p>Enter your new password to reset your account</p>
                    </div>
                    
                    <form [formGroup]="resetPasswordForm">
                        <div class="form-group">
                            <mat-form-field appearance="outline">
                                <mat-label>New Password</mat-label>
                                <mat-icon matPrefix>lock</mat-icon>
                                <input matInput formControlName="newPassword" [type]="hidePassword ? 'password' : 'text'" autocomplete="off">
                                <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button" aria-label="Toggle password visibility">
                                    <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                </button>
                                <mat-error *ngIf="resetPasswordForm.get('newPassword').hasError('required')">
                                    New Password is required
                                </mat-error>
                                <mat-error *ngIf="resetPasswordForm.get('newPassword').hasError('minlength')">
                                    Password must be at least 8 characters long
                                </mat-error>
                            </mat-form-field>
                        </div>
                        
                        <div class="form-group">
                            <mat-form-field appearance="outline">
                                <mat-label>Confirm Password</mat-label>
                                <mat-icon matPrefix>lock_outline</mat-icon>
                                <input matInput formControlName="confirmPassword" [type]="hideConfirmPassword ? 'password' : 'text'" autocomplete="off">
                                <button mat-icon-button matSuffix (click)="toggleConfirmPasswordVisibility()" type="button" aria-label="Toggle password visibility">
                                    <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                </button>
                                <mat-error *ngIf="resetPasswordForm.get('confirmPassword').hasError('required')">
                                    Confirm Password is required
                                </mat-error>
                                <mat-error *ngIf="resetPasswordForm.hasError('passwordMismatch')">
                                    Passwords do not match
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-actions">
                            <button class="login-btn" (click)="onResetPassword()">
                                <span>Update</span>
                                <mat-icon>arrow_forward</mat-icon>
                            </button>
                        </div>
                        <div class="form-footer">
                            <p>Remembered your password? <a routerLink="/login">Login</a></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <app-exam-footer class="footer"></app-exam-footer>
</div>